module.exports = __webpack_public_path__ + "static/media/content-image-2.0079f41d.png";